<template>
  <b-modal @show="onShow" @hidden="onHidden" ref="modal" v-model="opened" size="lg" title="Import / Export" static lazy
    ok-only ok-variant="danger" ok-title="Cancel" hide-footer class="wide-modal">
    <b-tabs content-class="mt-3" class="border-0">
      <b-tab active>
        <template #title>
          <i class="fas fa-file-export mr-2"></i>Export
        </template>
        <ExportForm />
      </b-tab>

      <b-tab>
        <template #title>
          <i class="fas fa-file-import mr-2"></i>Import
        </template>
        <ImportForm />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import ExportForm from "./ExportForm";
import ImportForm from "./ImportForm";

export default {
  data() {
    return {
      opened: true,
    }
  },
  components: {
    ImportForm,
    ExportForm,
  },
  methods: {
    onShow() { },
    onHidden() {
      this.$emit('finish');
      this.$emit('close');
    },
  },
}
</script>

<style scoped>
.wide-modal {
  max-width: 65vw !important;
}

::v-deep .modal-dialog {
  max-width: 65vw;
}
</style>
